var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6279 3.62932C28.3007 2.39755 27.3369 1.42745 26.1131 1.09823C23.8949 0.5 15 0.5 15 0.5C15 0.5 6.10522 0.5 3.88694 1.09823C2.66314 1.4275 1.69928 2.39755 1.37215 3.62932C0.777771 5.86198 0.777771 10.5202 0.777771 10.5202C0.777771 10.5202 0.777771 15.1784 1.37215 17.4111C1.69928 18.6429 2.66314 19.5726 3.88694 19.9018C6.10522 20.5 15 20.5 15 20.5C15 20.5 23.8948 20.5 26.1131 19.9018C27.3369 19.5726 28.3007 18.6429 28.6279 17.4111C29.2223 15.1784 29.2223 10.5202 29.2223 10.5202C29.2223 10.5202 29.2223 5.86198 28.6279 3.62932ZM12.0909 14.7495V6.29088L19.5252 10.5203L12.0909 14.7495Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c6f66940463abdf8e31716a7d3778ffe.svg";
export { ForwardRef as ReactComponent };